import { warnQuietly } from "@/lib/api";

/**
 * The handle to a half-finished quote.
 *
 * Only the session id is kept here — the answers themselves live on the server,
 * so a shared browser never holds a customer's figures. localStorage rather
 * than sessionStorage because the whole point is that it survives closing the
 * tab: the customer is told their answers are kept for 30 days.
 */
const STORAGE_KEY = "ttite_calc_session";

export function readStored() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    warnQuietly("could not read the saved session handle", error);
    return null;
  }
}

export function writeStored(value) {
  try {
    if (value) window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    else window.localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    warnQuietly("could not save the session handle", error);
  }
}
